import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
    ICreatePartnerClientBody,
    IPartnerClient,
    IPartnerClientWithSecret,
} from '../models/outbound/partner-client.model';

export const partnerClientActions = createActionGroup({
    source: 'PartnerClient',
    events: {
        'Load Clients': emptyProps(),
        'Load Clients Success': props<{ clients: IPartnerClient[] }>(),
        'Load Clients Failure': props<{ error: string }>(),

        // Success payloads carry the one-time secret for the OPEN MODAL ONLY —
        // the reducer strips it before anything reaches the store.
        'Create Client': props<{ body: ICreatePartnerClientBody }>(),
        'Create Client Success': props<{ client: IPartnerClientWithSecret }>(),
        'Create Client Failure': props<{ error: string }>(),

        'Rotate Secret': props<{ id: string }>(),
        'Rotate Secret Success': props<{ client: IPartnerClientWithSecret }>(),
        'Rotate Secret Failure': props<{ error: string }>(),

        'Revoke Client': props<{ id: string }>(),
        'Revoke Client Success': props<{ id: string }>(),
        'Revoke Client Failure': props<{ error: string }>(),
    },
});
